import { useInscreenObserver } from '../useInscreenObserver';
import React from 'react';

type BottomReachedProps = {
    onBottomReachedFn: () => void;
    threshold?: number;
};
export const useBottomReached = ({ onBottomReachedFn }: BottomReachedProps) => {
    const bottomRef = React.useRef<HTMLDivElement | null>(null);

    const checkBottomReached = () => {
        if (bottomRef.current) {
            const isBottomReached =
                bottomRef.current.getBoundingClientRect().top <=
                window.innerHeight;
            if (isBottomReached) {
                onBottomReachedFn();
            }
        }
    };

    useInscreenObserver(bottomRef, checkBottomReached, {
        threshold: 0,
        once: true,
    });

    return { bottomRef };
};
